import React from 'react';
import { useTranslation } from 'react-i18next';
import './AccountShell.css';
import logo from '../../assets/rhemn-logo.png';

type Section = 'upgrade' | 'billing';

interface Props {
  section: Section;
  children: React.ReactNode;
}

const AccountShell: React.FC<Props> = ({ section, children }) => {
  const { t } = useTranslation(['account']);
  return (
    <div className="account-page">
      <aside className="account-sidebar">
        <div className="account-brand">
          <img src={logo} alt={t('account:shell.logo_alt')} className="account-brand-logo" />
        </div>
        <a className={`account-nav-link ${section === 'upgrade' ? 'active' : ''}`} href="/upgrade">{t('account:shell.navUpgrade')}</a>
        <a className={`account-nav-link ${section === 'billing' ? 'active' : ''}`} href="/billing">{t('account:shell.navBilling')}</a>
      </aside>
      <main className="account-main">{children}</main>
    </div>
  );
};

export default AccountShell;
